var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/classof-raw.js